import React from "react";
import { Row, Col } from "react-bootstrap";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card } from "react-bootstrap";
import useFeatureList from "./featureList";

export default function Features() {
  const featureList = useFeatureList();
  return (
    <section
      className="text-center p-5 rounded-3"
      style={{
        backgroundColor: "#f7f9f9",
        paddingTop: "3rem",
        paddingBottom: "3rem",
      }}
    >
      <Row className="justify-content-center text-center">
        <Col lg={8} xl={7}>
          <h1 className="fs-2 fs-sm-4 fs-md-5">Here's what's in it for you</h1>
          <p className="lead">
            Things you will get right out of the box with TopCX

            Hello QA
          </p>
        </Col>
      </Row>
      <Row className="mt-6">
        {featureList.map((service, index) => (
          <Col sm={12} md={6} lg={4} className="my-4" key={index}>
            <Card className={classNames("card-span h-100 position-relative")}>
              <div className="card-span-img">
                <FontAwesomeIcon
                  icon={service.media.icon}
                  className={classNames(
                    "fixed-size",
                    { [`text-${service.media.color}`]: service.media.color },
                    service.media.className
                  )}
                />
              </div>
              <Card.Body className="pt-6 pb-4">
                <h5 className="mb-2">{service.title}</h5>
                <p>{service.description}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </section>
  );
}
